import Model from './Model'

export default class VariationValue extends Model {

    schema() {
        return {
            id: null,
            shop_id: null,
            value: null,
            created_at: null,
            updated_at: null,
            editMode: false,
            inlineLoader: false,
            datasEditInline: {},
            deleted_at: null,
        }
    }

    populateEditMode() {
        this.datasEditInline = {
            value: this.value,
            shop_id: this.shop_id,
        }
    }

    setEditMode() {
        this.editMode = true
        this.populateEditMode();
    }

    cancelEditMode() {
        this.editMode = false
    }

    saveEditMode() {
        this.cancelEditMode()
        this.value = this.datasEditInline.value
        this.shop_id = this.datasEditInline.shop_id
        return this.datasEditInline
    }

}
